import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${themeColors.colorsDivider};
  margin: 0.5px 0;
`;
